var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "contractForm", attrs: { name: "contractForm" } },
    [
      _c("e-sidebar", {
        attrs: {
          id: "sidebar-cost-contract-supplier",
          title: _vm.edit
            ? _vm.$t("Editar Custo Contratado")
            : _vm.$t("Novo Custo Contratado"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: { save: _vm.saveContract, hidden: _vm.hideSidebar },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-store-combo", {
                          attrs: {
                            id: "cost-contract-supplier-store",
                            required: false,
                            "only-active-options": true,
                            "select-single-option": false,
                            placeholder: _vm.$t("Geral"),
                            instruction: _vm.$t(
                              "Deixe em branco para um custo geral (todas as lojas)"
                            ),
                          },
                          model: {
                            value: _vm.contractForm.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.contractForm, "storeId", $$v)
                            },
                            expression: "contractForm.storeId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-search-sku", {
                          attrs: {
                            id: "cost-contract-supplier-sku",
                            label: _vm.$t("Produto"),
                            required: true,
                            "only-active": true,
                            "include-fixed-assets": true,
                            "default-options": _vm.skuDefaultOptions,
                          },
                          model: {
                            value: _vm.contractForm.skuId,
                            callback: function ($$v) {
                              _vm.$set(_vm.contractForm, "skuId", $$v)
                            },
                            expression: "contractForm.skuId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "cost-contract-supplier-cost",
                            type: "text-number",
                            currency: "R$",
                            precision: 2,
                            label: _vm.$t("Custo"),
                            validation: "required|costGreaterThanZero",
                            "validation-rules": {
                              costGreaterThanZero: function (ref) {
                                var value = ref.value

                                return Number(value) > 0
                              },
                            },
                            "validation-messages": {
                              costGreaterThanZero: _vm.$t(
                                "O custo deve ser maior que zero"
                              ),
                            },
                          },
                          model: {
                            value: _vm.contractForm.costValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.contractForm,
                                "costValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "contractForm.costValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "cost-contract-supplier-valid-from",
                            type: "datepicker",
                            label: _vm.$t("Vigência de"),
                            placeholder: _vm.$t("dd/mm/aaaa"),
                            validation: "required",
                          },
                          model: {
                            value: _vm.contractForm.validFrom,
                            callback: function ($$v) {
                              _vm.$set(_vm.contractForm, "validFrom", $$v)
                            },
                            expression: "contractForm.validFrom",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "cost-contract-supplier-valid-to",
                            type: "datepicker",
                            label: _vm.$t("Vigência até"),
                            placeholder: _vm.$t("dd/mm/aaaa"),
                            instruction: _vm.$t(
                              "Deixe em branco para vigência sem limite"
                            ),
                            validation: "validToAfterValidFrom",
                            "validation-rules": {
                              validToAfterValidFrom: function (ref) {
                                var value = ref.value

                                return (
                                  !value ||
                                  !_vm.contractForm.validFrom ||
                                  new Date(value) >
                                    new Date(_vm.contractForm.validFrom)
                                )
                              },
                            },
                            "validation-messages": {
                              validToAfterValidFrom: _vm.$t(
                                "A vigência até deve ser posterior à vigência de"
                              ),
                            },
                          },
                          model: {
                            value: _vm.contractForm.validTo,
                            callback: function ($$v) {
                              _vm.$set(_vm.contractForm, "validTo", $$v)
                            },
                            expression: "contractForm.validTo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }